import { TrackingSchemaTypes } from 'tracking'

export interface TourTrackingEvent {
  event: any
  properties: Record<string, any>
}

export const trackWizardTourShown = (step: 1 | 2 | 3 | 4): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'wizard',
    tour_action: 'shown',
    tour_step: step,
  },
})

export const trackWizardTourSkipped = (step: 1 | 2 | 3 | 4): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'wizard',
    tour_action: 'skipped',
    tour_step: step,
  },
})

export const trackWizardStepCompleted = (step: 1 | 2 | 3 | 4): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'wizard',
    tour_action: 'step_completed',
    tour_step: step,
  },
})

export const trackDashboardTourShown = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'dashboard',
    tour_action: 'shown',
  },
})

export const trackDashboardTourSkipped = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'dashboard',
    tour_action: 'skipped',
  },
})

export const trackPlanCreated = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'plan',
    tour_action: 'created',
  },
})

export const trackTimerStartedFirstTime = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'timer',
    tour_action: 'started_first_time',
  },
})

export const trackSessionCompletedFirstTime = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'session',
    tour_action: 'completed_first_time',
  },
})

export const trackRestartCycleTourShown = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'dashboard',
    tour_action: 'shown',
  },
})

export const trackRestartCycleTourSkipped = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'dashboard',
    tour_action: 'skipped',
  },
})

export const trackTimerCardTourShown = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'timer',
    tour_action: 'shown',
  },
})

export const trackTimerCardTourSkipped = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'timer',
    tour_action: 'skipped',
  },
})

export const trackTimerFullScreenTourShown = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'timer',
    tour_action: 'shown',
  },
})

export const trackTimerFullScreenTourSkipped = (): TourTrackingEvent => ({
  event: TrackingSchemaTypes.TourEvent,
  properties: {
    tour_type: 'timer',
    tour_action: 'skipped',
  },
})
